import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ListboxChangeEvent } from 'primeng/listbox';

@Component({
  selector: 'app-invoice-datepicker',
  templateUrl: './invoice-datepicker.component.html',
  styleUrls: ['./invoice-datepicker.component.scss'],
  providers: [DialogService]
})
export class InvoiceDatepickerComponent implements OnInit {
  date = new Date();

  invoiceOptions = [
    { name: 'On Receipt', code: 'onReceipt', days: '0' },
    { name: 'Within 15 Days', code: '15days', days: '15' },
    { name: 'Within 30 Days', code: '30days', days: '30' },
    { name: 'Within 45 Days', code: '45days', days: '45' },
    { name: 'Within 90 Days', code: '90days', days: '90' }
  ];
  selectedInvoiceOption: { name: string; code: string; days: string } = {
    name: 'On Receipt',
    code: 'onReceipt',
    days: '0'
  };

  constructor(
    public dialogService: DialogService,
    public messageService: MessageService,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {}

  selectedOption(selectEvent: ListboxChangeEvent) {
    const optionValue = selectEvent.value;
    if (optionValue === 'onReceipt') {
      this.date = new Date();
      this.date.setDate(this.date.getDate());
    }
    if (optionValue === '15days') {
      this.date = new Date();
      this.date.setDate(this.date.getDate() + 15);
    }
    if (optionValue === '30days') {
      this.date = new Date();
      this.date.setDate(this.date.getDate() + 30);
    }
    if (optionValue === '45days') {
      this.date = new Date();
      this.date.setDate(this.date.getDate() + 45);
    }
    if (optionValue === '90days') {
      this.date = new Date();
      this.date.setDate(this.date.getDate() + 90);
    }
  }

  updateSelectedOptionBasedOnSelectedDate() {
    const today = new Date();
    const selectedDate = this.date;

    const Difference_In_Time = selectedDate.getTime() - today.getTime();
    const Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));

    const selectedInvoiceOption = this.invoiceOptions.find(
      (x) => x.days === Difference_In_Days.toString()
    );

    if (selectedInvoiceOption) {
      this.selectedInvoiceOption = selectedInvoiceOption;
    }
  }

  resetDate() {
    this.date = new Date();
    this.date.setDate(this.date.getDate());
  }
  public setDueDate() {
    this.ref.close(this.date);
  }
}
